<template>
  <div>
    <div class="mainswiper">
      <left-nav title="出国留学" navCode="145"></left-nav>
      <div class="mid-part">
        <main-nav :data="gobroadMainNav"></main-nav>
        <div class="content">
          <div class="admodel"><ad-model adCode="60"></ad-model></div>
          <hot-article></hot-article>
          <div class="right-part">
            <login-table></login-table>
            <news title_1="最新优惠" title_2="推荐专题" :adCode="214" :newsData="newsData"></news>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from '@/common-components/Channelleftnav'
import News from '@/common-components/News'
import LoginTable from './components/Logintable'
import { getArticle } from 'js/getArticle.js'
import { gobroadMainNav } from 'js/gobroad/mainnav.js'
import MainNav from '@/common-components/Mainnav'
import AdModel from '@/common-components/AdModel'
import hotArticle from './components/Hotarticle.vue'
export default {
  name: 'firstScreen',
  components: {
    LeftNav,
    News,
    LoginTable,
    MainNav,
    AdModel,
    hotArticle
  },
  data () {
    return {
      newsData: [],
      gobroadMainNav
    }
  },
  created () {
    this.getNewsData()
  },
  methods: {
    getNewsData () {
      getArticle('1172', 3, '_WWW').then(response => {
        this.newsData = response
      })
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
.mainswiper >>> .navList
  height: 100%
.admodel >>> #outer
  height: 335px !important
  width: 750px !important
  img
    height: 100% !important
    width: 100% !important
.mainswiper
  width: 1200px
  height: 524px
  margin: 0 auto
  overflow: hidden
  display: flex
  .mid-part
    float: left
    display: flex
    flex: 1
    flex-direction: column
    .content
      position: relative
      .admodel
        float: left
      .right-part
        display: flex
        height: 472px
        width: 251px
        flex-direction: column
        position: absolute
        right: 2px
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/swiper/Swiper.vue